import Skiing from "../Assets/skiing.jpg";
import BikeTrips from "../Assets/biketrips.jpg";
import Trekking from "../Assets/trekking.jpg";
import Rafting from "../Assets/Rafting.jpg";
import Camping from "../Assets/camping.jpg";
import Expedition from "../Assets/expedition.jpg";
import Chardham from "../Assets/chardham.jpg";
import Cycling from "../Assets/cycling.jpg";
import Snowboarding from "../Assets/snowboarding.jpg";
import Rock from "../Assets/rockClimbing.jpg";
import skiing from "../Assets/skiing.svg";
import rockclimbing from "../Assets/rockclimbing.svg";
import trekking from "../Assets/trekking.svg";
import expedition from "../Assets/expedition.svg";
import biketrips from "../Assets/motorbike.svg";
import camping from "../Assets/tent.svg";
import cycling from "../Assets/cycling.svg";
import rafting from "../Assets/raft.svg";
import chardham from "../Assets/temple.svg";

const category = [
  {
    Name: "Trekking",
    img: Trekking,
    quote: "“Every mountain top is within reach if you just keep climbing.”",
    icon: trekking,
  },
  {
    Name: "Expedition",
    img: Expedition,
    quote: "“Life is either a daring adventure or nothing.”",
    icon: expedition,
  },
  {
    Name: "Skiing",
    img: Skiing,
    quote: "“A pair of skis are the ultimate transportation to freedom.”",
    icon: skiing,
  },
  {
    Name: "Camping",
    img: Camping,
    quote: "“The stars were better company anyway”",
    icon: camping,
  },
  {
    Name: "Spiritual Tours",
    img: Chardham,
    quote: "“Chardham yatra washes away all sins and opens doors for Moksha”",
    icon: chardham,
  },
  {
    Name: "Bike Trips",
    img: BikeTrips,
    quote: "“The best view comes after the hardest climb.”",
    icon: biketrips,
  },
  {
    Name: "Rafting",
    img: Rafting,
    quote:
      "“The first river you paddle runs through the rest of your life. It bubbles up in pools and eddies to remind you who you are.”",
    icon: rafting,
  },
  {
    Name: "Cycling",
    img: Cycling,
    quote: "“Nothing compares to the simple pleasure of riding a bike”",
    icon: cycling,
  },
  {
    Name: "Rock Climbing",
    img: Rock,
    quote: "“The greatest pleasures come after the highest climb”",
    icon: rockclimbing,
  },
  {
    Name: "Snowboarding",
    img: Snowboarding,
    quote:
      "“Some people attach snowboards to their feet, very few attach them to their souls”",
  },
];

export default category;
